import PropTypes from 'prop-types';
import { Component } from 'react';

import './CharacterCountVisibleTextarea.scss';

const propTypes = {
  maxCharacterCount: PropTypes.number,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
};

const defaultProps = {
  maxCharacterCount: 200,
  name: '',
  placeholder: '',
  value: '',
  onBlur() {},
  onChange() {},
};

class CharacterCountVisibleTextarea extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const { maxCharacterCount, onChange } = this.props;
    const { value } = e.target;

    if (value.length <= maxCharacterCount) {
      onChange(value);
    }
  }

  render() {
    const { maxCharacterCount, name, placeholder, value, onBlur } = this.props;

    return (
      <div className="CharacterCountVisibleTextarea">
        <textarea
          className="CharacterCountVisibleTextarea__textarea InputSet__text-area"
          name={name}
          placeholder={placeholder}
          style={{ resize: 'vertical' }}
          value={value}
          onBlur={onBlur}
          onChange={this.handleChange}
        />
        <div className="CharacterCountVisibleTextarea__count">
          {value.length} / {maxCharacterCount}
        </div>
      </div>
    );
  }
}

CharacterCountVisibleTextarea.propTypes = propTypes;
CharacterCountVisibleTextarea.defaultProps = defaultProps;

export default CharacterCountVisibleTextarea;
